import { PHOTO } from './media';

/**
 * The weekly line-up. Each entry gets its own page at /whats-on/<slug>,
 * mirroring the old /theme-name/<slug> URLs.
 *
 * `day` drives the "on today" highlight: 0 = Sunday … 6 = Saturday.
 */
export const EVENTS = [
  {
    id: 'burger-mondays',
    name: 'Burger Mondays',
    when: 'Every Monday',
    time: '12pm – 10pm',
    day: [1],
    branches: 'Kyanja & Bugolobi',
    blurb: 'The smash burger, the way Monday needs it.',
    body: 'Our smash beef burger takes over the pass every Monday — griddled hard, stacked properly, and priced so a bad start to the week doesn’t stay bad for long.',
    long: 'Our menu is inspired by the everyday Ugandan table, reimagined with creativity and care. It’s all about seasonality, simplicity and soul — served in a way that feels familiar but tastes like something new.',
    image: PHOTO.burger,
  },
  {
    id: 'taco-tuesday',
    name: 'Taco Tuesday',
    when: 'Every Tuesday',
    time: '12pm – 10pm',
    day: [2],
    branches: 'Kyanja & Bugolobi',
    blurb: 'Soft shells, hard flavours, all evening.',
    body: 'A rotating board of tacos built on whatever the market gave us that morning. Order three. You will order three more.',
    long: 'Food tastes better when it feels like it belongs to the neighbourhood. Not fancy belonging. Real belonging. We exist to make those small, everyday moments feel a little bigger, a little warmer, and a lot more delicious.',
    image: PHOTO.tacos,
  },
  {
    id: 'happy-hour',
    name: 'Happy Hour',
    when: 'Monday – Thursday',
    time: '4pm – 7pm',
    day: [1, 2, 3, 4],
    branches: 'Kyanja & Bugolobi',
    blurb: 'The three hours the week actually belongs to you.',
    body: 'Cocktails, house pours and cold beer at happy-hour prices from four until seven, every weekday. The bar fills from the middle out.',
    long: 'Our menu is inspired by the everyday Ugandan table, reimagined with creativity and care. It’s all about seasonality, simplicity and soul — served in a way that feels familiar but tastes like something new.',
    image: PHOTO.spritz,
  },
  {
    id: 'slow-sundays',
    name: 'Slow Sundays',
    when: 'Sundays',
    time: '12pm – 10pm',
    day: [0],
    branches: 'Kyanja & Bugolobi',
    blurb: 'No rush. That is the entire offer.',
    body: 'Long tables, longer lunches, and a soundtrack that never asks you to leave. Bring everyone. Stay until the light goes.',
    long: 'The Local was built on a simple idea. Food tastes better when it feels like it belongs to the neighbourhood. Not fancy belonging. Real belonging. We exist to make those small, everyday moments feel a little bigger, a little warmer, and a lot more delicious.',
    image: PHOTO.plate10,
  },
];

export const getEvent = (slug) => EVENTS.find((e) => e.id === slug);

/** Simple weekly grid rendered on the What's On page. */
export const WEEK = [
  { day: 'Monday', items: ['Burger Mondays · 12pm – 10pm', 'Happy Hour · 4pm – 7pm'] },
  { day: 'Tuesday', items: ['Taco Tuesday · 12pm – 10pm', 'Happy Hour · 4pm – 7pm'] },
  { day: 'Wednesday', items: ['Happy Hour · 4pm – 7pm'] },
  { day: 'Thursday', items: ['Happy Hour · 4pm – 7pm'] },
  { day: 'Friday', items: ['Kitchen & bar until late'] },
  { day: 'Saturday', items: ['Kitchen & bar until late'] },
  { day: 'Sunday', items: ['Slow Sundays · 12pm – 10pm'] },
];
